module.exports = __webpack_public_path__ + "img/knu2_gallery14.9620b633.jpg";